<template>
  <dialog-email
    ref="dialog-email"
    :contentKey="contentKey"
    :contentMap="contentMap"
    :data="emailData"
    :isLoading="isLoading"
    @on-submit-email="handlerSubmit"
    @close="handleClose"
  />
</template>

<script>

import { ServiceContacts } from '@/services/Contacts'
import { ServiceCompanies } from '@/services/Companies'
import { ServicePayments } from '@/services/Payments'
import { readProps } from '@/utils/objects'
import { toDate, toPriceCurrency } from '@/utils/filters'
import { getCurrentEmployee } from '@/utils/shared'
import { ServiceEmailMessages } from '@/services/email-messages'

export const tableConfig = [
  {
    field: 'invoiceNumber',
    labelKey: 'invoice-number',
    sortable: true
  },
  {
    field: 'invoice.po',
    labelKey: 'po',
    sortable: true,
    template: (data) => (data.invoice && data.invoice.po) || '--'
  },
  {
    field: 'invoiceDate',
    labelKey: 'invoice-date',
    convertor: (v, data) => toDate(v),
    excelType: 'd'
  },
  {
    field: 'invoiceAmount',
    labelKey: 'invoice-amount',
    convertor: (v, data) => toPriceCurrency(v, data.currency.title),
    sortable: true
  },
  {
    field: 'invoiceDueDate',
    labelKey: 'invoice-due-date',
    convertor: (v, data) => toDate(v),
    excelType: 'd'
  }
]

export default {
  name: 'index',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  props: {
    paymentID: {
      required: true
    },
    companyID: {
      required: true
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.get('currentUser')
    }
  },
  data () {
    return {
      contentKey: 'payment-status-email',
      contentMap: {},
      emailData: {},
      companyName: '',
      isLoading: true
    }
  },
  methods: {
    show () {
      this.$refs['dialog-email'].show()
      this.loadData()
    },
    prepareData ({ company, companyContacts, listPayments }) {
      const { name } = company
      const tablePayments = this.createTableListPayments(listPayments)

      const employee = this.currentUser

      this.emailData = {
        subject: `${name} account statement from Bel-Air Express`,
        emailToList: companyContacts.map(({ email }) => email),
        replyTo: employee.email || ''
      }

      this.contentMap = {
        tablePayments,
        accountStatement: this.L10n('account-statement')
      }
    },
    close () {
      this.$refs['dialog-email'].close()
    },
    async loadData () {
      this.isLoading = true
      try {
        const { data: company } = await ServiceCompanies.getDynamic(this.companyID, {
          select: 'id,name',
          filter: `id = ${this.companyID}`
        })
        this.companyName = company.name
        const { data: dataCompanyContacts } = await ServiceContacts.getInvoicePaymentContacts({ companyID: this.companyID })

        let listPayments = []

        try {
          const { data } = await ServicePayments.getAllByCustomer(this.companyID)
          listPayments = data
        } catch (e) {
        }

        this.prepareData({ company, companyContacts: dataCompanyContacts.value, listPayments })
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    async handlerSubmit (emailData) {
      this.isLoading = true
      try {
        await ServiceEmailMessages.send(emailData)
        const employee = getCurrentEmployee()
        const description = `${employee.name} Sent reminder ${this.companyName}`
        await ServicePayments.createLog({ paymentID: this.paymentID, description })
        this.$bus.$emit('on-update-log')
        this.$refs['dialog-email'].hide()
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    handleClose () {
      this.reset()
    },
    reset () {
      this.contentMap = {}
      this.emailData = {}
      this.companyName = ''
    },
    createTableListPayments (listPayments) {
      const table = document.createElement('table')

      if (!listPayments.length) {
        return ''
      }

      const tHead = document.createElement('thead')
      const trHead = document.createElement('tr')
      tableConfig.forEach(({ labelKey }) => {
        const th = document.createElement('th')
        th.innerHTML = this.L10n(labelKey)
        trHead.appendChild(th)
      })
      tHead.appendChild(trHead)

      table.appendChild(tHead)

      const tBody = document.createElement('tbody')
      listPayments.forEach((payment, i) => {
        const tr = document.createElement('tr')
        tableConfig.forEach(({ field, convertor }) => {
          const td = document.createElement('td')
          const value = readProps(field, payment)
          td.innerHTML = convertor ? convertor(value, payment) : value
          tr.appendChild(td)
        })
        tBody.appendChild(tr)
      })

      table.appendChild(tBody)

      table.setAttribute('width', '100%')

      const wrap = document.createElement('div')
      wrap.appendChild(table)

      return wrap.innerHTML
    }
  }
}
</script>
